var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.shouldShow,
          expression: "shouldShow"
        }
      ],
      staticClass: "session-timeout-expired-overlay",
      attrs: {
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "session-timeout-expired-title"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "session-timeout-expired-card",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c(
            "h5",
            {
              staticClass: "session-timeout-expired-title",
              attrs: { id: "session-timeout-expired-title" }
            },
            [_vm._v(" " + _vm._s(_vm.$t("session_timeout.title")) + " ")]
          ),
          _c("div", { staticClass: "session-timeout-expired" }, [
            _c(
              "div",
              { staticClass: "expired-icon" },
              [
                _c("feather-icon", {
                  attrs: { icon: "AlertCircleIcon", size: "36" }
                })
              ],
              1
            ),
            _c("p", { staticClass: "expired-message" }, [
              _vm._v(" " + _vm._s(_vm.$t("session_timeout.expired")) + " ")
            ])
          ]),
          _c("div", { staticClass: "session-timeout-expired-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.goToLogin }
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("session_timeout.go_to_login")) + " "
                )
              ]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }